module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_iterators.js
 ** module id = 253
 ** module chunks = 1
 **/